import { useResetAppAtoms } from './app';
import { useResetAuthAtoms } from './auth';
import { useResetNotificationsAtoms } from './notification';
import { useResetPlanAtoms } from './plan';
import { useResetProfileAtoms } from './profile';
import { useResetQueryAtoms } from './query';
import { useResetTutorialsAtoms } from './tutorials';
import { useResetUIAtoms } from './ui';
import { useResetSearchAtoms } from './header';

export * from './app';
export * from './auth';
export * from './notification';
export * from './plan';
export * from './profile';
export * from './query';
export * from './tutorials';
export * from './ui';
export * from './header';

export function useResetAtoms() {
  const resetAppAtoms = useResetAppAtoms();
  const resetAuthAtoms = useResetAuthAtoms();
  const resetNotificationsAtoms = useResetNotificationsAtoms();
  const resetPlanAtoms = useResetPlanAtoms();
  const resetProfileAtoms = useResetProfileAtoms();
  const resetQueryAtoms = useResetQueryAtoms();
  const resetTutorialsAtoms = useResetTutorialsAtoms();
  const resetUIAtoms = useResetUIAtoms();
  const resetSearchAtoms = useResetSearchAtoms();

  return () => {
    resetAuthAtoms();
    resetAppAtoms();
    resetNotificationsAtoms();
    resetPlanAtoms();
    resetProfileAtoms();
    resetUIAtoms();
    resetQueryAtoms();
    resetTutorialsAtoms();
    resetSearchAtoms();
  };
}
